import { Button, WarningModal } from '@basqet-dashboard/common/components';
import { useEmailVerification } from '@basqet-dashboard/common/hooks';
import PropTypes from 'prop-types';
import React from 'react';

const EmailVerificationModal = ({ onModalClose }) => {
  const { isLoading: verifyingEmail, emailVerification } = useEmailVerification();

  return (
    <WarningModal onModalClose={onModalClose} header={{ name: 'Account', cursive: 'Verification' }}>
      <div className="account__verification">
        <p>Complete your email verification to create a settlement account</p>
        <Button isFull onClick={emailVerification} isLoading={verifyingEmail}>
          Request Email Verification
        </Button>
        <Button isFull variant="outline" onClick={onModalClose}>
          Cancel
        </Button>
      </div>
    </WarningModal>
  );
};

EmailVerificationModal.propTypes = {
  onModalClose: PropTypes.func
};

export { EmailVerificationModal };
